import ILabelProps from "@/interfaces/Props/Label/ILabelProps";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const Label = (props: ILabelProps) => {
  const {
    id,
    values,
    color,
    align,
    classes,
    gutterBottom,
    paragraph,
    sx,
    variant,
    variantMapping,
    component = "span",
  } = props;
  return (
    <Typography
      align={align}
      classes={classes}
      color={color}
      gutterBottom={gutterBottom}
      paragraph={paragraph}
      sx={sx}
      variant={variant}
      variantMapping={variantMapping}
      component={component}
    >
      <FormattedMessage id={id} values={values} />
    </Typography>
  );
};

export default Label;
